export default __webpack_public_path__ + "static/running-across-bridge-472ce87f06d6dc984584868ebc55cad3.jpg";